import React, { useEffect, useState } from "react";
import { Button, Heading, MenuButton, Modal, Select } from "../../components/Common";
import {
  Box,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
} from "@mui/material";
import { VscFilter } from "react-icons/vsc";
import { Search, Pagination } from "../../components/Common/Table";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { MdMoreVert, MdPassword } from "react-icons/md";
import { HiOutlineTrash } from "react-icons/hi";
import { AiOutlineEdit } from "react-icons/ai";
import FilterAuditors from "./FilterAuditors";
import { useNavigate } from "react-router-dom";
import { BsEye } from "react-icons/bs";
import {
  AuditorList,
  AuditorCreate,
  AuditorUpdate,
  AuditorDelete,
  AuditorStatusChange,
  AdminChnagePasswordOnMail,
  AuditorStatusChangeNew,
  AuditorApprovalStatusUpdate,
} from "../../Service/Auditor.service";
import { addAuditorValidationSchema } from "../../helper/validation";
import {
  addAuditorInitialValues,
  filterAuditorInitialValues,
} from "../../helper/initialValues";
import { notificationSuccess } from "../../state/Action/NotificationAction";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import moment from "moment";
import TableRowsLoader from "../../components/Common/Loader/Skeleton";
import Notification from "../../components/Common/Notification/Notification";
import { IsDelete, IsWrite } from "../../helper/handlePermission";

const approvalStatusList = [
  { id: 0, name: "Pending" },
  { id: 1, name: "Approval" },
  { id: 2, name: "Rejected" },
];

const Auditors = () => {
  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
    para: "",
    head: "",
  });
  const [search, setSearch] = useState(() => {
    return sessionStorage.getItem("auditors_search") || "";
  });
  const [page, setPage] = React.useState(() => {
    const saved = sessionStorage.getItem("auditors_page");
    return saved !== null && !isNaN(Number(saved)) ? Number(saved) : 0;
  });
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [auditordata, setAuditorData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const saved = sessionStorage.getItem("auditors_rows_per_page");
    return saved !== null && !isNaN(Number(saved)) ? Number(saved) : 10;
  });
  const [sortConfig, setSortConfig] = useState(() => {
    const saved = sessionStorage.getItem("auditors_sort");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {}
    }
    return { key: "", direction: "" };
  });
  const [showNotification, setShowNotification] = useState({
    show: false,
    type: "",
    message: "",
  });
  const [tabValue, setTabValue] = useState(() => {
    const saved = sessionStorage.getItem("auditors_tab");
    return saved !== null && !isNaN(Number(saved)) ? Number(saved) : 0;
  });
  const editPermissions = IsWrite("Auditor");
  const deletePermissions = IsDelete("Auditor");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.setItem("auditors_tab", tabValue);
  }, [tabValue]);

  useEffect(() => {
    sessionStorage.setItem("auditors_page", page);
  }, [page]);

  useEffect(() => {
    sessionStorage.setItem("auditors_rows_per_page", rowsPerPage);
  }, [rowsPerPage]);

  useEffect(() => {
    sessionStorage.setItem("auditors_search", search);
  }, [search]);

  useEffect(() => {
    sessionStorage.setItem("auditors_sort", JSON.stringify(sortConfig));
  }, [sortConfig]);

  const formik = useFormik({
    initialValues: addAuditorInitialValues,
    onSubmit: async (value) => {
      const payload = {
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        mobile: value.mobile,
        location: value.location,
      };

      let res = isModalOpen?.isEdit
        ? await AuditorUpdate(isModalOpen?.id, payload)
        : await AuditorCreate(payload);
      if (res?.status) {
        dispatch(
          notificationSuccess({
            show: true,
            type: "success",
            message: res.message || "Success",
          })
        );
        getAuditorList();
        setIsModalOpen({
          open: false,
          currentComponent: "",
          para: "",
          head: "",
          isEdit: false,
          isView: false,
        });
        formik.resetForm();
      } else {
        if (res.message == "Email or mobile number already exists.") {
          formik.setFieldError("mobile", res.message);
        } else {
          setShowNotification({
            show: true,
            type: "error",
            message:
              res.message || "Something went wrong. Please try again later.",
          });
        }
      }
    },
    validationSchema: addAuditorValidationSchema,
  });

  const formik1 = useFormik({
    initialValues: {
      ...filterAuditorInitialValues,
      status: sessionStorage.getItem("auditors_status_filter") || "",
    },
    onSubmit: async (value) => {
      if (value?.status !== undefined && value?.status !== null && value?.status !== "") {
        sessionStorage.setItem("auditors_status_filter", value.status);
      } else {
        sessionStorage.removeItem("auditors_status_filter");
      }
      setOpenDrawer(false);
      getAuditorList();
    },
  });

  const getAuditorList = async () => {
    setAuditorData([]);
    let selectQry = `?search=${search}&page=${
      page + 1
    }&limit=${rowsPerPage}&status=${formik1.values.status}&sortBy=${
      sortConfig.key
    }&sortFlag=${sortConfig.direction}&is_mobile=${tabValue === 0 ? '1' : 'not_1'}`;
    let res = await AuditorList(selectQry);
    if (res?.status) {
      setAuditorData(res.data);
      setTotalData(res.total);
      if (res.total > 0 && page * rowsPerPage >= res.total) {
        const lastPage = Math.max(0, Math.ceil(res.total / rowsPerPage) - 1);
        setPage(lastPage);
      }
    } else {
      setAuditorData(null);
    }
  };

  useEffect(() => {
    getAuditorList();
  }, [search, page, rowsPerPage, sortConfig, tabValue]);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };
  const changeStatus = async () => {
    let res =
      isModalOpen && isModalOpen?.currentComponent == "status"
        ? await AuditorStatusChange(isModalOpen?.id)
        : isModalOpen && isModalOpen?.currentComponent == "delete"
        ? await AuditorDelete(isModalOpen?.id)
        : isModalOpen && isModalOpen?.currentComponent == "changepassword"
        ? await AdminChnagePasswordOnMail(isModalOpen?.id)
        : isModalOpen && isModalOpen?.currentComponent == "approval"
        ? await AuditorStatusChangeNew({ id: isModalOpen?.id, status: isModalOpen?.is_approval === 1 ? 0 : 1 })
        : null;
    if (res?.status) {
      dispatch(
        notificationSuccess({
          show: true,
          type: "success",
          message: res.message || "Success",
        })
      );
      getAuditorList();
      setIsModalOpen({
        open: false,
        currentComponent: "",
        para: "",
        head: "",
        id: "",
      });
    } else {
      dispatch(
        notificationSuccess({
          show: true,
          type: "error",
          message:
            res.message || "Something went wrong. Please try again later.",
        })
      );
    }
  };

  const handleApprovalStatusChange = async (id, status) => {
    let res = await AuditorApprovalStatusUpdate(id, { is_approved: status });
    if (res?.status) {
      dispatch(
        notificationSuccess({
          show: true,
          type: "success",
          message: res.message || "Approval status updated successfully",
        })
      );
      getAuditorList();
    } else {
      dispatch(
        notificationSuccess({
          show: true,
          type: "error",
          message: res.message || "Failed to update approval status",
        })
      );
    }
  };

  return (
    <>
      <Heading head={"Auditor"} />
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => {
            setTabValue(newValue);
            setPage(0);
            sessionStorage.setItem("auditors_tab", newValue);
            sessionStorage.setItem("auditors_page", 0);
          }}
          aria-label="auditor tabs"
        >
          <Tab label="Requested" />
          <Tab label="Auditor" />
        </Tabs>
      </Box>
      <Stack gap={2} mt={1}>
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Search search={search} setSearch={setSearch} setPage={setPage} />
          <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
            {editPermissions && tabValue === 1 && (
              <Button
                buttonName={"Add"}
                size="small"
                onClick={() => {
                  setIsModalOpen({
                    open: true,
                    currentComponent: "addauditor",
                  });
                }}
              />
            )}

            <Button
              buttonName={<VscFilter />}
              style={{ padding: "10px 11px" }}
              color="white"
              size="small"
              onClick={toggleDrawer}
              variant="contained"
              // onClick={handleShowFilters}
              sx={{ mt: 2 }}
            />
            <FilterAuditors
              openDrawer={openDrawer}
              toggleDrawer={toggleDrawer}
              formik={formik1}
              auditordata={auditordata}
            />
          </Stack>
        </Stack>
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Device-id</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Name</div>
                  </Stack>
                </TableCell>

                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Mobile</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Email</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Current Location</div>
                  </Stack>
                </TableCell>
                <TableCell
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSortConfig({
                      key: "createdAt",
                      direction:
                        sortConfig &&
                        sortConfig.key === "createdAt" &&
                        sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Created Date</div>
                    {sortConfig &&
                    sortConfig.key === "createdAt" &&
                    sortConfig.direction === "desc" ? (
                      <IoIosArrowUp
                        sx={{
                          color: "rgba(107, 114, 128, .5)",
                          fontSize: "17px",
                          marginLeft: "3px",
                        }}
                      />
                    ) : (
                      <IoIosArrowDown
                        sx={{
                          color: "rgba(107, 114, 128, .5)",
                          fontSize: "17px",
                          marginLeft: "3px",
                        }}
                      />
                    )}
                  </Stack>
                </TableCell>
                {tabValue === 0 && (
                  <TableCell style={{ cursor: "pointer" }}>
                    <Stack
                      flexDirection={"row"}
                      gap={2}
                      alignItems={"center"}
                      justifyContent={"start"}
                    >
                      <div>Approval</div>
                    </Stack>
                  </TableCell>
                )}
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Status</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Action</div>
                  </Stack>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {auditordata &&
                auditordata.map((data, i) => (
                  <TableRow
                    key={i}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(`/auditor-details`, { state: data?._id })
                    }
                  >
                    <TableCell style={{ textAlign: "left" }}>
                      {data?.deviceId || "-"}
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      {data?.firstName} {data?.lastName}
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      {data?.mobile}
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      {data?.email}
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      {data?.location}
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      {moment(data?.createdAt).format("DD/MM/YYYY")}
                    </TableCell>
                    {tabValue === 0 && (
                      <TableCell onClick={(e) => e.stopPropagation()}>
                        <Select
                          size="small"
                          value={data?.is_approved}
                          selectList={approvalStatusList}
                          onChange={(e) => {
                            if (editPermissions) {
                              handleApprovalStatusChange(data?._id, e.target.value);
                            } else {
                              dispatch(
                                notificationSuccess({
                                  show: true,
                                  type: "error",
                                  message: "You don't have permission to change approval status",
                                })
                              );
                            }
                          }}
                          style={{
                            height: "35px",
                            fontSize: "13px",
                            "& .MuiSelect-select": {
                              padding: "8px 14px",
                            }
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell>
                      <Switch
                        size="small"
                        checked={data?.status === 1}
                        disabled={formik1.values.status == 2}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (editPermissions) {
                            setIsModalOpen({
                              id: data?._id,
                              open: true,
                              currentComponent: "status",
                              head: "Change Status",
                              para: "Are you sure you want to Change the Status?",
                              status: data?.status,
                            });
                          } else {
                            dispatch(
                              notificationSuccess({
                                show: true,
                                type: "error",
                                message: "You don't have permission to change status",
                              })
                            );
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell
                      onClick={(e) => e.stopPropagation()}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <DropdownMenu.Root>
                        <DropdownMenu.Trigger className="chatDropDown">
                          <MenuButton
                            icon={
                              <MdMoreVert
                                style={{ color: "#000", fontSize: "18px" }}
                              />
                            }
                            width="30px"
                            height="33px"
                          />
                        </DropdownMenu.Trigger>
                        <DropdownMenu.Content
                          className="chatDropDownContent"
                          align="end"
                        >
                          <DropdownMenu.Item className="chatDropDownMenu">
                            <Stack
                              flexDirection={"row"}
                              gap={1}
                              alignItems={"center"}
                              onClick={() =>
                                navigate(`/auditor-details`, {
                                  state: data?._id,
                                })
                              }
                            >
                              <BsEye style={{ fontSize: "15px" }} />
                              <Box sx={{ fontSize: "13px" }}>{"View"}</Box>
                            </Stack>
                          </DropdownMenu.Item>
                          {editPermissions && (
                            <DropdownMenu.Item className="chatDropDownMenu">
                              <Stack
                                flexDirection={"row"}
                                gap={1}
                                alignItems={"center"}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "firstName",
                                    data?.firstName
                                  );
                                  formik.setFieldValue(
                                    "lastName",
                                    data?.lastName
                                  );
                                  formik.setFieldValue("email", data?.email);
                                  formik.setFieldValue("mobile", data?.mobile);
                                  formik.setFieldValue(
                                    "location",
                                    data?.location
                                  );
                                  setIsModalOpen({
                                    open: true,
                                    currentComponent: "addauditor",
                                    id: data?._id,
                                    isEdit: true,
                                  });
                                }}
                              >
                                <AiOutlineEdit style={{ fontSize: "15px" }} />
                                <Box sx={{ fontSize: "13px" }}>{"Edit"}</Box>
                              </Stack>
                            </DropdownMenu.Item>
                          )}
                          {deletePermissions && (
                            <DropdownMenu.Item className="chatDropDownMenu">
                              <Stack
                                flexDirection={"row"}
                                gap={1}
                                alignItems={"center"}
                                onClick={() =>
                                  setIsModalOpen({
                                    open: true,
                                    currentComponent: "delete",
                                    head: "Delete Auditor",
                                    para: "Are you sure you want to Delete this Gorup?",
                                    id: data?._id,
                                  })
                                }
                              >
                                <HiOutlineTrash style={{ fontSize: "15px" }} />
                                <Box sx={{ fontSize: "13px" }}>{"Delete"}</Box>
                              </Stack>
                            </DropdownMenu.Item>
                          )}
                          {editPermissions && (
                            <DropdownMenu.Item className="chatDropDownMenu">
                              <Stack
                                flexDirection={"row"}
                                gap={1}
                                alignItems={"center"}
                                onClick={() => {
                                  setIsModalOpen({
                                    id: data?._id,
                                    open: true,
                                    currentComponent: "changepassword",
                                    head: "Password Change",
                                    para: "Are You Sure to Change Password ",
                                  });
                                }}
                              >
                                <MdPassword style={{ fontSize: "15px" }} />
                                <Box sx={{ fontSize: "13px" }}>
                                  {"Change Password"}
                                </Box>
                              </Stack>
                            </DropdownMenu.Item>
                          )}
                        </DropdownMenu.Content>
                      </DropdownMenu.Root>
                    </TableCell>
                  </TableRow>
                ))}
              {auditordata == null ? (
                <TableRow>
                  <TableCell
                    sx={{
                      color: "silver",
                      textAlign: "center",
                      paddingTop: "90px",
                      borderBottom: "none",
                      fontSize: "30px",
                    }}
                    colSpan={tabValue === 0 ? "9" : "8"}
                  >
                    No records to display
                  </TableCell>
                </TableRow>
              ) : auditordata && auditordata.length == 0 ? (
                <TableRowsLoader colNumber={tabValue === 0 ? 9 : 8} rowsNum={10} />
              ) : (
                ""
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {auditordata != null && (
            <Pagination
              count={10}
              shape="rounded"
              totalData={totalData}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </div>
      </Stack>
      <Modal
        modalOpen={isModalOpen}
        formik={formik}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          formik.resetForm();
        }}
        handelClick={changeStatus}
      />
      <Notification show={showNotification} setShow={setShowNotification} />
    </>
  );
};

export default Auditors;
